import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiPost, operationsClient } from '@/lib/api';
import { proposalTemplateEndpoints } from '@/lib/api/endpoints';
import { proposalTemplateKeys } from '@/lib/queryKeys';
import type { ProposalTemplate, CreateProposalTemplateDto } from '@/types/proposalTemplate';

/**
 * Creates a new proposal template via the operations microservice.
 */
export const useCreateProposalTemplate = createMutationHook<
  ProposalTemplate,
  CreateProposalTemplateDto
>({
  mutationFn: (dto) =>
    apiPost<ProposalTemplate, CreateProposalTemplateDto>(
      operationsClient,
      proposalTemplateEndpoints.create(),
      dto,
    ),
  onSuccess: (_data, _variables, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: proposalTemplateKeys.lists() });
    toast.success('Proposal template created');
  },
});
